
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "emailInput", "sendButton", "delivery", "closeButton"]

  open() {
    const selected = this.element.querySelectorAll(
      'input[name="specification_ids[]"]:checked'
    )

    if (selected.length === 0) {
      alert("Select at least one specification.")
      return
    }

    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")

    this.emailInputTarget.disabled = false
    this.emailInputTarget.required = true

    this.sendButtonTargets.forEach((button) => {
      button.disabled = false
    })

    this.closeButtonTarget.focus()
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")

    this.emailInputTarget.disabled = true
    this.emailInputTarget.required = false

    this.sendButtonTargets.forEach((button) => {
      button.disabled = true
    })
  }

  connect() {
    this.element.addEventListener("submit", this.handleSubmit)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleSubmit)
  }

  handleSubmit = (event) => {
    const submitter = event.submitter
    if (!submitter) return

    const selected = this.element.querySelectorAll(
      'input[name="specification_ids[]"]:checked'
    )

    if (selected.length === 0) {
      event.preventDefault()
      alert("Select at least one specification.")
      return
    }

    this.deliveryTarget.value =
      submitter.dataset.delivery === "email" ? "email" : ""
  }
}
